/**
 * Static Chart Browser fallback snapshot.
 *
 * Chart Browser's canonical static source is public/chart-history/v1/latest.json.
 * This committed sample is only the last-resort fallback when that baked JSON
 * cannot be fetched, keeping chart browsing useful without adding accounts,
 * servers, storage, or a required runtime API.
 *
 * Shape:
 *   { capturedAt, countries: { [country]: { [chartType]: ChartBrowserEntry[] } } }
 */

const EMPTY_SNAPSHOT = Object.freeze([]);

function deepFreeze(value) {
  if (!value || typeof value !== 'object' || Object.isFrozen(value)) return value;
  Object.freeze(value);
  for (const child of Object.values(value)) deepFreeze(child);
  return value;
}

export const CHART_SNAPSHOT = deepFreeze({
  "capturedAt": "2026-06-19",
  "countries": {
    "us": {
      "top-free": [
        {
          "rank": 1,
          "trackId": 1508186374,
          "name": "Peacock TV: Stream TV & Movies",
          "artistName": "Peacock TV LLC",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/3f/79/dc/3f79dccc-2e54-c955-5712-45d332cd2177/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 2,
          "trackId": 1632713844,
          "name": "Kalshi: Trade the Cup",
          "artistName": "KalshiEX LLC",
          "primaryGenre": "Finance",
          "genreId": "6015",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/b7/5c/14/b75c14fc-9558-d10d-3792-5cd9247f9b56/flavor_productionAppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 3,
          "trackId": 6746049430,
          "name": "FOX One: Live News, Sports, TV",
          "artistName": "Fox Digital Services, LLC",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/00/ec/33/00ec3381-b756-542e-3a77-50955634add0/AppIcon-0-1x_U007epad-0-1-0-85-220-0.png/100x100bb.png"
        },
        {
          "rank": 4,
          "trackId": 6448311069,
          "name": "ChatGPT",
          "artistName": "OpenAI OpCo, LLC",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/c7/eb/e6c7eb69-ade8-00b8-3454-d359249c6a0a/AppIcon-0-0-1x_U007epad-0-0-0-1-0-P3-85-220.png/100x100bb.png"
        },
        {
          "rank": 5,
          "trackId": 680595680,
          "name": "Telemundo: Series y TV en vivo",
          "artistName": "NBCUniversal Media, LLC",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/6d/0d/89/6d0d89ad-9310-afb1-2271-927f4d85ed0c/AppIcon-1x_U007epad-0-1-0-85-220-0.png/100x100bb.png"
        },
        {
          "rank": 6,
          "trackId": 1465944282,
          "name": "Love Island USA",
          "artistName": "ITV America Inc.",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/f4/ff/0f/f4ff0fa3-24a1-f86e-541d-0cac6a3ea260/AppIcon-0-0-1x_U007emarketing-0-11-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 7,
          "trackId": 905401434,
          "name": "Fubo: Watch Live TV & Sports",
          "artistName": "fuboTV Inc.",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/f6/4a/be/f64abecc-fe20-8b82-42b7-14b8d835db54/Fubo-0-0-1x_U007epad-0-1-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 8,
          "trackId": 6447582581,
          "name": "Netflix Game Controller",
          "artistName": "Netflix, Inc.",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/22/03/21/22032103-e65c-2bea-9a13-0fa2e791f0d9/AppIcon-0-0-1x_U007epad-0-1-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 9,
          "trackId": 6446901002,
          "name": "Threads",
          "artistName": "Instagram, Inc.",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/a0/72/07/a07207e3-9102-3699-30db-9a086554ffd3/Prod-0-0-1x_U007ephone-0-0-0-1-0-0-P3-85-220.png/100x100bb.png"
        },
        {
          "rank": 11,
          "trackId": 6648798962,
          "name": "Polymarket",
          "artistName": "Polymarket",
          "primaryGenre": "Finance",
          "genreId": "6015",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/55/a8/8c/55a88c9d-234c-e778-d289-b623c41abddd/AppIcon2-0-1x_U007ephone-0-1-0-sRGB-85-220-0.png/100x100bb.png"
        },
        {
          "rank": 12,
          "trackId": 6477489729,
          "name": "Google Gemini",
          "artistName": "Google",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/f7/dc/9e/f7dc9ef9-1731-1c66-7e00-ca58d011f1d9/AppIcon-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 13,
          "trackId": 284815942,
          "name": "Google",
          "artistName": "Google",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/04/5e/47/045e4716-99d8-f058-1d82-b36131a7d3ae/SuperG_ios26-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-0-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 14,
          "trackId": 1500855883,
          "name": "CapCut: Photo & Video Editor",
          "artistName": "Bytedance Pte. Ltd",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/bb/37/1f/bb371fbb-68b3-a368-186d-947bfad8e540/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 15,
          "trackId": 310633997,
          "name": "WhatsApp Messenger",
          "artistName": "WhatsApp Inc.",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/77/f3/0e/77f30e4d-537d-e50c-7986-46b9fcd7d623/AppIcon-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 16,
          "trackId": 886445756,
          "name": "Tubi: Movies & Live TV",
          "artistName": "Tubi, Inc",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/df/fb/00/dffb00ac-fd93-86a1-1162-74c5445140e4/AppIcon-0-0-1x_U007epad-0-1-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 17,
          "trackId": 1488269261,
          "name": "Whatnot: Shop, Sell, Connect",
          "artistName": "Whatnot Inc.",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/93/f4/67/93f4676a-04b8-2f82-0dac-5d1d7ba7b750/AppIcon-0-0-1x_U007ephone-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 18,
          "trackId": 6532603739,
          "name": "FWC2026 Mobile Tickets",
          "artistName": "FIFA",
          "primaryGenre": "Sports",
          "genreId": "6004",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b7/f9/8f/b7f98f34-318d-ca76-9943-4c7e838adb1e/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 19,
          "trackId": 585027354,
          "name": "Google Maps",
          "artistName": "Google",
          "primaryGenre": "Navigation",
          "genreId": "6010",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/06/26/aa/0626aaa5-0c1b-d7b7-598e-e2cb8a1f8523/maps_2025-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 20,
          "trackId": 518684914,
          "name": "Depop - Buy & Sell Clothes",
          "artistName": "Depop Ltd",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/74/61/ba/7461ba55-1734-9fe7-84b7-82a24e05549b/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 21,
          "trackId": 1641486558,
          "name": "Temu: Shop Like a Billionaire",
          "artistName": "Temu",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/d1/cf/30/d1cf3071-76fb-6fc5-673f-3a6c381fbd98/AppIcon-0-1x_U007epad-0-1-0-0-85-220-0.png/100x100bb.png"
        }
      ],
      "top-paid": [
        {
          "rank": 1,
          "trackId": 932747118,
          "name": "Shadowrocket",
          "artistName": "Shadow Launch Technology Limited",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d2/3a/31/d23a310a-0bce-973d-ba58-f051b99a6c64/AppIcon-0-0-1x_U007epad-0-1-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 2,
          "trackId": 373493387,
          "name": "AnkiMobile Flashcards",
          "artistName": "Anki Software, LLC",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/30/6b/da/306bdac5-3088-c97f-c682-e4626bfc6b43/AppIcon-0-0-1x_U007emarketing-0-5-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 3,
          "trackId": 916366645,
          "name": "Procreate Pocket",
          "artistName": "Savage Interactive Pty Ltd",
          "primaryGenre": "Graphics & Design",
          "genreId": "6027",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/d2/18/61/d2186101-9232-1bcf-251a-8ca543a12010/AppIcon-0-0-1x_U007emarketing-0-6-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 4,
          "trackId": 404990064,
          "name": "SkyView®",
          "artistName": "Terminal Eleven LLC",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/97/65/03/9765034e-0237-e438-3fa1-d4bdc65f5c8b/AppIcon-0-0-1x_U007emarketing-0-5-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 5,
          "trackId": 432850619,
          "name": "FL Studio Mobile",
          "artistName": "Image Line Software",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/81/2f/a2/812fa2f0-5147-e2fc-d2cb-421da0146685/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 6,
          "trackId": 578665578,
          "name": "Threema. The Secure Messenger",
          "artistName": "Threema GmbH",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/7a/68/fd/7a68fd73-cc8c-1de3-c6ae-541858bbce0e/AppIcon-0-0-1x_U007epad-0-0-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 7,
          "trackId": 904237743,
          "name": "Things 3",
          "artistName": "Cultured Code GmbH & Co. KG",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d0/1e/fe/d01efe6f-a09d-713e-0b02-b75c2865c215/AppIcon-0-0-1x_U007ephone-0-0-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 8,
          "trackId": 298206806,
          "name": "iReal Pro",
          "artistName": "Technimo LLC",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/4b/3e/dc/4b3edcfe-90fe-c207-f775-e75eba73ef2d/App_Icon-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 9,
          "trackId": 1633243177,
          "name": "Ableton Note",
          "artistName": "Ableton AG",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/62/b2/8d/62b28dc8-e7f7-58ca-5531-8878a1b54afa/AppIcon-1x_U007emarketing-0-8-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 10,
          "trackId": 577628510,
          "name": "TeamSpeak 3",
          "artistName": "TeamSpeak Systems Inc",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/98/33/e9/9833e9ee-fb56-df24-0ec1-d7eb12308d05/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 11,
          "trackId": 1062022008,
          "name": "LumaFusion",
          "artistName": "Luma Touch LLC",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a6/45/39/a64539ec-1521-9f96-fcd0-c7ac15a753ec/LumaFusionComposerIcon-0-1x_U007epad-0-1-0-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 12,
          "trackId": 596026805,
          "name": "PhotoPills",
          "artistName": "PhotoPills S.L.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/5e/60/70/5e60703c-75ac-14d2-ec12-bf81cee85008/Photopills-liquid-glass-logo-0-1x_U007epad-0-1-0-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 13,
          "trackId": 357421934,
          "name": "PeakFinder",
          "artistName": "PeakFinder GmbH",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/74/63/c4/7463c42f-333b-627b-8415-c6ba477d7aaa/AppIcon-0-0-1x_U007epad-0-1-0-P3-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 14,
          "trackId": 1303222868,
          "name": "Paprika Recipe Manager 3",
          "artistName": "Hindsight Labs LLC",
          "primaryGenre": "Food & Drink",
          "genreId": "6023",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/a0/11/fa/a011fa7f-a52b-e7f6-b376-5287cd7c281d/AppIcon-0-0-1x_U007emarketing-0-8-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 15,
          "trackId": 1164801111,
          "name": "AutoSleep: Watch Sleep Tracker",
          "artistName": "Tantsissa",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/fb/92/fa/fb92fadb-a7c2-0fc6-8fcf-082973492641/AppIcon-0-0-1x_U007ephone-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 16,
          "trackId": 1062745479,
          "name": "HeartWatch: Heart Rate Monitor",
          "artistName": "Tantsissa",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/bb/43/9a/bb439acd-67f8-8909-df62-eb65d3c246f0/AppIcon-0-0-1x_U007ephone-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 17,
          "trackId": 288419283,
          "name": "RadarScope",
          "artistName": "Base Velocity, LLC",
          "primaryGenre": "Weather",
          "genreId": "6001",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/30/88/a9/3088a97e-f8b7-b37a-f13c-0633b7c3cdba/App_Icon-0-0-1x_U007emarketing-0-0-0-8-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 18,
          "trackId": 497716362,
          "name": "TonalEnergy Tuner & Metronome",
          "artistName": "TonalEnergy, Inc",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/73/41/4b/73414b5f-0ab4-eb76-b031-5226e38337de/AppIcon-0-0-1x_U007emarketing-0-11-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 19,
          "trackId": 1241909999,
          "name": "WorkOutDoors",
          "artistName": "CCS Ltd",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b1/4b/02/b14b0228-1a44-ed1e-9d25-0e1c606f401a/AppIcon-0-0-1x_U007emarketing-0-6-0-0-GLES2_U002c0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 20,
          "trackId": 650684932,
          "name": "OBD Fusion",
          "artistName": "OCTech, LLC",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/60/8d/f8/608df835-24f9-efe5-7552-fe11a0222658/appicon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        }
      ],
      "top-grossing": [
        {
          "rank": 1,
          "trackId": 6448311069,
          "name": "ChatGPT",
          "artistName": "OpenAI OpCo, LLC",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/c7/eb/e6c7eb69-ade8-00b8-3454-d359249c6a0a/AppIcon-0-0-1x_U007epad-0-0-0-1-0-P3-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 2,
          "trackId": 835599320,
          "name": "TikTok - Videos, Shop & LIVE",
          "artistName": "TikTok Ltd.",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/c8/cf/06/c8cf0625-604f-e6c1-575f-e49014356b5b/TikTok_AppIcon26-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 3,
          "trackId": 544007664,
          "name": "YouTube",
          "artistName": "Google",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/20/ea/87/20ea8738-6fac-caea-ccc1-72d8375a2310/logo_youtube_2024_q4_color-0-0-1x_U007emarketing-0-0-0-7-0-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 4,
          "trackId": 431946152,
          "name": "Roblox",
          "artistName": "Roblox Corporation",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/ac/a5/f6/aca5f69c-4a2e-44ea-9db2-7d87acf84b9d/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 5,
          "trackId": 1094591345,
          "name": "Pokémon GO",
          "artistName": "Niantic, Inc.",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b0/1d/a8/b01da803-6787-7011-bbb2-febab12f84de/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 6,
          "trackId": 6479970832,
          "name": "Pokémon TCG Pocket",
          "artistName": "The Pokemon Company",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/54/12/78/541278bd-ccac-156d-b027-a46e1cd536bb/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 7,
          "trackId": 553834731,
          "name": "Candy Crush Saga",
          "artistName": "King",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a1/c5/92/a1c59272-aace-ff82-0b16-ca93a87cb33c/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 8,
          "trackId": 529479190,
          "name": "Clash of Clans",
          "artistName": "Supercell",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/ed/78/c5/ed78c5e2-9a0b-fd1f-58fa-a51a50a283ed/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 9,
          "trackId": 1053012308,
          "name": "Clash Royale",
          "artistName": "Supercell",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/37/80/1e/37801e4c-717a-6d48-5023-5770fdbb2e01/AppIcon-0-0-1x_U007emarketing-0-7-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 10,
          "trackId": 1482155847,
          "name": "Royal Match",
          "artistName": "Dream Games",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/50/3d/ab/503dabf4-c381-e224-5630-5b031703c08d/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 11,
          "trackId": 1621328561,
          "name": "MONOPOLY GO!",
          "artistName": "Scopely, Inc.",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/35/63/c3/3563c36e-dc8f-45d4-1991-d9ab6db39557/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 12,
          "trackId": 324684580,
          "name": "Spotify: Music and Podcasts",
          "artistName": "Spotify",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d0/5c/0b/d05c0bcb-1d14-bf33-c74e-11518d8f245c/AppIcon-0-0-1x_U007epad-0-1-0-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 13,
          "trackId": 443904275,
          "name": "LINE",
          "artistName": "LINE Corporation",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/03/ce/cb/03cecbf9-9517-859d-b6c3-59afc3be6fd5/basic_default-0-0-1x_U007epad-0-6-0-0-sRGB-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 14,
          "trackId": 1500855883,
          "name": "CapCut: Photo & Video Editor",
          "artistName": "Bytedance Pte. Ltd",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/bb/37/1f/bb371fbb-68b3-a368-186d-947bfad8e540/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 15,
          "trackId": 547702041,
          "name": "Tinder Dating App: Date & Chat",
          "artistName": "Tinder LLC",
          "primaryGenre": "Lifestyle",
          "genreId": "6012",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/67/7b/27/677b27da-88b8-5b27-329a-eaedf9e07609/AppIcon-0-0-1x_U007emarketing-0-8-0-0-P3-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 16,
          "trackId": 985746746,
          "name": "Discord - Talk, Play, Hang Out",
          "artistName": "Discord Inc.",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/3c/fd/7d/3cfd7d5b-2976-2064-4023-c0bbfc4062ce/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 17,
          "trackId": 570060128,
          "name": "Duolingo: Language Lessons",
          "artistName": "Duolingo",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/35/31/5e/35315e16-db2f-e88d-1821-6a1b8f67d936/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 18,
          "trackId": 897446215,
          "name": "Canva: AI Video & Photo Editor",
          "artistName": "Canva",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/54/63/b5/5463b52f-ac99-4be1-6f74-fef35e4e3ce7/AppIcon-0-0-1x_U007epad-0-11-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 19,
          "trackId": 587366035,
          "name": "Picsart AI Photo Editor, Video",
          "artistName": "PicsArt, Inc.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/3f/78/a9/3f78a998-dbf1-a5d5-1bc7-6071a2183983/AppIcon-0-0-1x_U007emarketing-0-8-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 20,
          "trackId": 460177396,
          "name": "Twitch: Live Streaming",
          "artistName": "Twitch Interactive, Inc.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/df/b3/e6dfb315-9c80-4c32-e688-9d38cfabd6d6/TwitchAppIcon-0-0-1x_U007epad-0-1-0-0-0-0-85-220.png/100x100bb.jpg"
        }
      ]
    },
    "jp": {
      "top-free": [
        {
          "rank": 1,
          "trackId": 6448311069,
          "name": "ChatGPT",
          "artistName": "OpenAI OpCo, LLC",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/c7/eb/e6c7eb69-ade8-00b8-3454-d359249c6a0a/AppIcon-0-0-1x_U007epad-0-0-0-1-0-P3-85-220.png/100x100bb.png"
        },
        {
          "rank": 2,
          "trackId": 6477489729,
          "name": "Google Gemini",
          "artistName": "Google",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/f7/dc/9e/f7dc9ef9-1731-1c66-7e00-ca58d011f1d9/AppIcon-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 3,
          "trackId": 1129523589,
          "name": "DAZN (ダゾーン) スポーツをライブ中継",
          "artistName": "DAZN Limited",
          "primaryGenre": "Sports",
          "genreId": "6004",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/bc/02/87/bc02878a-dc33-ed57-8f81-bb8ac35da1ed/AppIcon-0-0-1x_U007emarketing-0-8-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 4,
          "trackId": 6667104573,
          "name": "ジハンピ",
          "artistName": "SUNTORY BEVERAGE SOLUTION LIMITED",
          "primaryGenre": "Food & Drink",
          "genreId": "6023",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/75/1c/7e/751c7e24-7540-b175-c703-3040355c3cef/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/100x100bb.png"
        },
        {
          "rank": 5,
          "trackId": 955641819,
          "name": "ミスタードーナツ",
          "artistName": "DUSKIN CO., LTD.",
          "primaryGenre": "Food & Drink",
          "genreId": "6023",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/30/68/6b/30686ba6-f823-4529-9ea4-34efb6e5d42b/AppIcon-1x_U007emarketing-0-8-0-85-220-0.png/100x100bb.png"
        },
        {
          "rank": 7,
          "trackId": 6446901002,
          "name": "Threads",
          "artistName": "Instagram, Inc.",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/a0/72/07/a07207e3-9102-3699-30db-9a086554ffd3/Prod-0-0-1x_U007ephone-0-0-0-1-0-0-P3-85-220.png/100x100bb.png"
        },
        {
          "rank": 9,
          "trackId": 6451037644,
          "name": "マツキヨココカラ公式アプリ",
          "artistName": "株式会社マツキヨココカラ&カンパニー",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/76/f1/9d/76f19d3e-5946-f16a-800a-d45856b1a413/AppIcon-production-0-0-1x_U007ephone-0-1-85-220.png/100x100bb.png"
        },
        {
          "rank": 10,
          "trackId": 1476359069,
          "name": "マイナポータル",
          "artistName": "デジタル庁",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/13/1c/20/131c2022-f1ab-f9e7-75ee-a2074693e582/AppIcon-0-0-1x_U007ephone-0-6-0-sRGB-85-220-0.png/100x100bb.png"
        },
        {
          "rank": 11,
          "trackId": 910133705,
          "name": "31Club サーティワン公式アプリ",
          "artistName": "B-R 31 ICE CREAM CO., LTD.",
          "primaryGenre": "Food & Drink",
          "genreId": "6023",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/8d/11/9d/8d119d88-a1c7-2d7e-462a-31d4a448aa74/AppIcon-0-0-1x_U007ephone-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 12,
          "trackId": 1485352913,
          "name": "Pokémon HOME",
          "artistName": "The Pokemon Company",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/34/55/27/3455273b-5736-2e6c-1a88-c05860e9e4b2/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 13,
          "trackId": 6747368440,
          "name": "NHKプラス（NHK ONE対応）",
          "artistName": "NHK (Japan Broadcasting Corporation)",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/13/d5/0c/13d50c3b-5245-1a74-3280-5f3a98a8ca32/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 14,
          "trackId": 1644042837,
          "name": "Hypic：画像編集、写真加工",
          "artistName": "Bytedance Pte. Ltd",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/13/bc/ba/13bcbad3-7512-41ad-c631-5120a4e86ac4/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 15,
          "trackId": 6466987025,
          "name": "DAISOアプリ",
          "artistName": "株式会社大創産業",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/4c/c3/4f/4cc34fe1-4918-3f0f-d4b5-70347a94648a/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 16,
          "trackId": 6739188587,
          "name": "Rocket Now : 出前/フードデリバリー",
          "artistName": "CP One Japan G.K.",
          "primaryGenre": "Food & Drink",
          "genreId": "6023",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/2e/d8/c3/2ed8c30c-3783-e649-c737-0738536596e0/AppIcon-0-0-1x_U007ephone-0-11-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 17,
          "trackId": 1456118550,
          "name": "バーガーキング Burger King",
          "artistName": "Burger King Japan",
          "primaryGenre": "Food & Drink",
          "genreId": "6023",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/67/6a/5f/676a5f2f-754e-4c92-a395-4604b18d92d8/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/100x100bb.png"
        },
        {
          "rank": 18,
          "trackId": 6454900894,
          "name": "デジタル認証アプリ",
          "artistName": "デジタル庁",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/df/fc/b4/dffcb4cf-7876-4a3b-40d2-2f83d3d032c7/AppIcon-0-1x_U007ephone-0-1-85-220-0.png/100x100bb.png"
        },
        {
          "rank": 19,
          "trackId": 385724144,
          "name": "ホットペッパービューティー/美容院・ネイルなどのサロン予約",
          "artistName": "Recruit Co.,Ltd.",
          "primaryGenre": "Lifestyle",
          "genreId": "6012",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/1b/94/f4/1b94f47a-1f06-a02f-c362-3a545e72b188/AppIcon-0-0-1x_U007ephone-0-1-85-220.png/100x100bb.png"
        },
        {
          "rank": 20,
          "trackId": 535886823,
          "name": "Google Chrome - ウェブブラウザ",
          "artistName": "Google",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/80/99/f0/8099f08e-bf96-5992-4dcd-49bec71f66db/AppIcon-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 21,
          "trackId": 1496925861,
          "name": "ゆうちょ通帳アプリ-銀行 アプリ",
          "artistName": "Japan Post Bank Co., Ltd.",
          "primaryGenre": "Finance",
          "genreId": "6015",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/87/31/0d/87310d4c-9291-2f6f-ab04-2afb161d0792/AppIcon-0-0-1x_U007emarketing-0-8-0-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 22,
          "trackId": 732775964,
          "name": "しまむらパーク",
          "artistName": "しまむら",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/41/7b/57/417b5762-7da0-9781-b23e-6f45dbc5ab76/AppIcon-0-0-1x_U007emarketing-0-6-0-85-220.png/100x100bb.png"
        }
      ],
      "top-paid": [
        {
          "rank": 1,
          "trackId": 932747118,
          "name": "Shadowrocket",
          "artistName": "Shadow Launch Technology Limited",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d2/3a/31/d23a310a-0bce-973d-ba58-f051b99a6c64/AppIcon-0-0-1x_U007epad-0-1-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 2,
          "trackId": 373493387,
          "name": "AnkiMobile Flashcards",
          "artistName": "Anki Software, LLC",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/30/6b/da/306bdac5-3088-c97f-c682-e4626bfc6b43/AppIcon-0-0-1x_U007emarketing-0-5-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 3,
          "trackId": 916366645,
          "name": "Procreate Pocket",
          "artistName": "Savage Interactive Pty Ltd",
          "primaryGenre": "Graphics & Design",
          "genreId": "6027",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/d2/18/61/d2186101-9232-1bcf-251a-8ca543a12010/AppIcon-0-0-1x_U007emarketing-0-6-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 4,
          "trackId": 404990064,
          "name": "SkyView®",
          "artistName": "Terminal Eleven LLC",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/97/65/03/9765034e-0237-e438-3fa1-d4bdc65f5c8b/AppIcon-0-0-1x_U007emarketing-0-5-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 5,
          "trackId": 432850619,
          "name": "FL Studio Mobile",
          "artistName": "Image Line Software",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/81/2f/a2/812fa2f0-5147-e2fc-d2cb-421da0146685/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 6,
          "trackId": 578665578,
          "name": "Threema。安全なメッセンジャー",
          "artistName": "Threema GmbH",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/7a/68/fd/7a68fd73-cc8c-1de3-c6ae-541858bbce0e/AppIcon-0-0-1x_U007epad-0-0-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 7,
          "trackId": 904237743,
          "name": "Things 3",
          "artistName": "Cultured Code GmbH & Co. KG",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d0/1e/fe/d01efe6f-a09d-713e-0b02-b75c2865c215/AppIcon-0-0-1x_U007ephone-0-0-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 8,
          "trackId": 298206806,
          "name": "iReal Pro",
          "artistName": "Technimo LLC",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/4b/3e/dc/4b3edcfe-90fe-c207-f775-e75eba73ef2d/App_Icon-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 9,
          "trackId": 1633243177,
          "name": "Ableton Note",
          "artistName": "Ableton AG",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/62/b2/8d/62b28dc8-e7f7-58ca-5531-8878a1b54afa/AppIcon-1x_U007emarketing-0-8-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 10,
          "trackId": 577628510,
          "name": "TeamSpeak 3",
          "artistName": "TeamSpeak Systems Inc",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/98/33/e9/9833e9ee-fb56-df24-0ec1-d7eb12308d05/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 11,
          "trackId": 1062022008,
          "name": "LumaFusion",
          "artistName": "Luma Touch LLC",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a6/45/39/a64539ec-1521-9f96-fcd0-c7ac15a753ec/LumaFusionComposerIcon-0-1x_U007epad-0-1-0-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 12,
          "trackId": 596026805,
          "name": "PhotoPills",
          "artistName": "PhotoPills S.L.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/5e/60/70/5e60703c-75ac-14d2-ec12-bf81cee85008/Photopills-liquid-glass-logo-0-1x_U007epad-0-1-0-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 13,
          "trackId": 357421934,
          "name": "PeakFinder",
          "artistName": "PeakFinder GmbH",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/74/63/c4/7463c42f-333b-627b-8415-c6ba477d7aaa/AppIcon-0-0-1x_U007epad-0-1-0-P3-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 14,
          "trackId": 1303222868,
          "name": "Paprika レシピ・マネージャー３",
          "artistName": "Hindsight Labs LLC",
          "primaryGenre": "Food & Drink",
          "genreId": "6023",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/a0/11/fa/a011fa7f-a52b-e7f6-b376-5287cd7c281d/AppIcon-0-0-1x_U007emarketing-0-8-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 15,
          "trackId": 1164801111,
          "name": "AutoSleep 睡眠の追跡をWatchで",
          "artistName": "Tantsissa",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/fb/92/fa/fb92fadb-a7c2-0fc6-8fcf-082973492641/AppIcon-0-0-1x_U007ephone-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 16,
          "trackId": 1062745479,
          "name": "HeartWatch： 心拍数の測定と管理",
          "artistName": "Tantsissa",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/bb/43/9a/bb439acd-67f8-8909-df62-eb65d3c246f0/AppIcon-0-0-1x_U007ephone-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 17,
          "trackId": 288419283,
          "name": "RadarScope",
          "artistName": "Base Velocity, LLC",
          "primaryGenre": "Weather",
          "genreId": "6001",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/30/88/a9/3088a97e-f8b7-b37a-f13c-0633b7c3cdba/App_Icon-0-0-1x_U007emarketing-0-0-0-8-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 18,
          "trackId": 497716362,
          "name": "TonalEnergyチューナーとメトロノーム",
          "artistName": "TonalEnergy, Inc",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/73/41/4b/73414b5f-0ab4-eb76-b031-5226e38337de/AppIcon-0-0-1x_U007emarketing-0-11-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 19,
          "trackId": 1241909999,
          "name": "WorkOutDoors",
          "artistName": "CCS Ltd",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b1/4b/02/b14b0228-1a44-ed1e-9d25-0e1c606f401a/AppIcon-0-0-1x_U007emarketing-0-6-0-0-GLES2_U002c0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 20,
          "trackId": 650684932,
          "name": "OBD Fusion",
          "artistName": "OCTech, LLC",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/60/8d/f8/608df835-24f9-efe5-7552-fe11a0222658/appicon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        }
      ],
      "top-grossing": [
        {
          "rank": 1,
          "trackId": 6448311069,
          "name": "ChatGPT",
          "artistName": "OpenAI OpCo, LLC",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/c7/eb/e6c7eb69-ade8-00b8-3454-d359249c6a0a/AppIcon-0-0-1x_U007epad-0-0-0-1-0-P3-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 2,
          "trackId": 835599320,
          "name": "TikTok - Videos, Shop & LIVE",
          "artistName": "TikTok Ltd.",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/c8/cf/06/c8cf0625-604f-e6c1-575f-e49014356b5b/TikTok_AppIcon26-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 3,
          "trackId": 544007664,
          "name": "YouTube",
          "artistName": "Google",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/20/ea/87/20ea8738-6fac-caea-ccc1-72d8375a2310/logo_youtube_2024_q4_color-0-0-1x_U007emarketing-0-0-0-7-0-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 4,
          "trackId": 431946152,
          "name": "Roblox (ロブロックス)",
          "artistName": "Roblox Corporation",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/ac/a5/f6/aca5f69c-4a2e-44ea-9db2-7d87acf84b9d/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 5,
          "trackId": 1094591345,
          "name": "Pokémon GO",
          "artistName": "Niantic, Inc.",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b0/1d/a8/b01da803-6787-7011-bbb2-febab12f84de/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 6,
          "trackId": 6479970832,
          "name": "Pokémon TCG Pocket",
          "artistName": "The Pokemon Company",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/54/12/78/541278bd-ccac-156d-b027-a46e1cd536bb/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 7,
          "trackId": 553834731,
          "name": "キャンディークラッシュ",
          "artistName": "King",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a1/c5/92/a1c59272-aace-ff82-0b16-ca93a87cb33c/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 8,
          "trackId": 529479190,
          "name": "クラッシュ・オブ・クラン (Clash of Clans)",
          "artistName": "Supercell",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/ed/78/c5/ed78c5e2-9a0b-fd1f-58fa-a51a50a283ed/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 9,
          "trackId": 1053012308,
          "name": "クラッシュ・ロワイヤル (Clash Royale)",
          "artistName": "Supercell",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/37/80/1e/37801e4c-717a-6d48-5023-5770fdbb2e01/AppIcon-0-0-1x_U007emarketing-0-7-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 10,
          "trackId": 1482155847,
          "name": "ロイヤルマッチ（Royal Match)",
          "artistName": "Dream Games",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/50/3d/ab/503dabf4-c381-e224-5630-5b031703c08d/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 11,
          "trackId": 1621328561,
          "name": "MONOPOLY GO! (モノポリー GO!)",
          "artistName": "Scopely, Inc.",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/35/63/c3/3563c36e-dc8f-45d4-1991-d9ab6db39557/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 12,
          "trackId": 324684580,
          "name": "Spotify: 音楽とポッドキャスト",
          "artistName": "Spotify",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d0/5c/0b/d05c0bcb-1d14-bf33-c74e-11518d8f245c/AppIcon-0-0-1x_U007epad-0-1-0-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 13,
          "trackId": 443904275,
          "name": "LINE",
          "artistName": "LINE Corporation",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/03/ce/cb/03cecbf9-9517-859d-b6c3-59afc3be6fd5/basic_default-0-0-1x_U007epad-0-6-0-0-sRGB-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 14,
          "trackId": 1500855883,
          "name": "CapCut：写真＆動画エディター",
          "artistName": "Bytedance Pte. Ltd",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/bb/37/1f/bb371fbb-68b3-a368-186d-947bfad8e540/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 15,
          "trackId": 547702041,
          "name": "Tinder (ティンダー) - 出会い・マッチングアプリ",
          "artistName": "Tinder LLC",
          "primaryGenre": "Lifestyle",
          "genreId": "6012",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/67/7b/27/677b27da-88b8-5b27-329a-eaedf9e07609/AppIcon-0-0-1x_U007emarketing-0-8-0-0-P3-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 16,
          "trackId": 985746746,
          "name": "Discord - 一緒にしゃべって遊んで集まろう",
          "artistName": "Discord Inc.",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/3c/fd/7d/3cfd7d5b-2976-2064-4023-c0bbfc4062ce/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 17,
          "trackId": 570060128,
          "name": "Duolingo-英語/韓国語などのリスニングや英単語の練習",
          "artistName": "Duolingo",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/35/31/5e/35315e16-db2f-e88d-1821-6a1b8f67d936/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 18,
          "trackId": 897446215,
          "name": "Canva（キャンバ） - 信じられないほど、素晴らしく",
          "artistName": "Canva",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/54/63/b5/5463b52f-ac99-4be1-6f74-fef35e4e3ce7/AppIcon-0-0-1x_U007epad-0-11-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 19,
          "trackId": 587366035,
          "name": "Picsart (ピクスアート) 写真加工&動画編集アプリ",
          "artistName": "PicsArt, Inc.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/3f/78/a9/3f78a998-dbf1-a5d5-1bc7-6071a2183983/AppIcon-0-0-1x_U007emarketing-0-8-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 20,
          "trackId": 460177396,
          "name": "Twitch: ライブ配信",
          "artistName": "Twitch Interactive, Inc.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/df/b3/e6dfb315-9c80-4c32-e688-9d38cfabd6d6/TwitchAppIcon-0-0-1x_U007epad-0-1-0-0-0-0-85-220.png/100x100bb.jpg"
        }
      ]
    },
    "gb": {
      "top-free": [
        {
          "rank": 1,
          "trackId": 6737119425,
          "name": "GOV.UK One Login",
          "artistName": "Government Digital Service",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/d8/26/fe/d826fe6a-24e4-7602-0671-2207783e60a9/GlassAppIcon-0-0-1x_U007ephone-0-1-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 3,
          "trackId": 1591214233,
          "name": "InPost UK",
          "artistName": "InPost UK Ltd",
          "primaryGenre": "Lifestyle",
          "genreId": "6012",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/9c/fd/36/9cfd36a1-3ef3-8b53-7840-e138729af0c5/AppIcon-1x_U007emarketing-0-6-0-85-220-0.png/100x100bb.png"
        },
        {
          "rank": 4,
          "trackId": 446079916,
          "name": "ITVX",
          "artistName": "ITV",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/99/20/a5/9920a5a6-abd6-eb85-de7c-4e4ee02948c3/ITVX-0-0-1x_U007epad-0-1-0-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 5,
          "trackId": 6448311069,
          "name": "ChatGPT",
          "artistName": "OpenAI OpCo, LLC",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/c7/eb/e6c7eb69-ade8-00b8-3454-d359249c6a0a/AppIcon-0-0-1x_U007epad-0-0-0-1-0-P3-85-220.png/100x100bb.png"
        },
        {
          "rank": 6,
          "trackId": 6477489729,
          "name": "Google Gemini",
          "artistName": "Google",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/f7/dc/9e/f7dc9ef9-1731-1c66-7e00-ca58d011f1d9/AppIcon-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 8,
          "trackId": 6476561442,
          "name": "FIFA World Cup 2026™",
          "artistName": "FIFA",
          "primaryGenre": "Sports",
          "genreId": "6004",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/7b/c5/03/7bc503eb-1864-b7b8-3e26-594d4f8fd6b3/AppIcon-0-0-1x_U007ephone-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 9,
          "trackId": 6446788829,
          "name": "Apple Sports",
          "artistName": "Apple",
          "primaryGenre": "Sports",
          "genreId": "6004",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/00/05/79/00057923-40fd-ff12-e2b1-ce49eddaaf24/AppIcon-0-1x_U007ephone-0-0-0-1-0-P3-0-85-220-0.png/100x100bb.png"
        },
        {
          "rank": 10,
          "trackId": 1488269261,
          "name": "Whatnot: Shop, Sell, Connect",
          "artistName": "Whatnot Inc.",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/93/f4/67/93f4676a-04b8-2f82-0dac-5d1d7ba7b750/AppIcon-0-0-1x_U007ephone-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 11,
          "trackId": 416580485,
          "name": "BBC iPlayer",
          "artistName": "BBC Media Applications Technologies Limited",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/cb/dc/b0/cbdcb0cd-dea6-bcbf-3c0a-73b522d1303a/AppIcon-0-0-1x_U007epad-0-0-0-1-0-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 12,
          "trackId": 500003565,
          "name": "Ticketmaster－Buy, Sell Tickets",
          "artistName": "Ticketmaster",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/72/72/e9/7272e93c-5491-1b2b-7e39-05c98abe54cc/AppIcon-0-0-1x_U007emarketing-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 13,
          "trackId": 368677368,
          "name": "Uber - Request a ride",
          "artistName": "Uber Technologies, Inc.",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/fc/90/8d/fc908dcb-c787-81a1-2189-524df4a82962/AppIcon-0-0-1x_U007emarketing-0-8-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 14,
          "trackId": 514561561,
          "name": "HMRC",
          "artistName": "HMRC",
          "primaryGenre": "Finance",
          "genreId": "6015",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/17/57/1e/17571eb3-552d-dc28-edc7-e932035f600d/AppIcon-Release-Prod-0-0-1x_U007emarketing-0-8-0-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 15,
          "trackId": 1223471316,
          "name": "Shop: All your favorite brands",
          "artistName": "Shopify Inc.",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/0f/19/a5/0f19a521-b043-ea18-ad89-ccb99efb0a8d/AppIcon-0-0-1x_U007ephone-0-11-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 16,
          "trackId": 932493382,
          "name": "Revolut — Mobile Finance",
          "artistName": "Revolut Ltd",
          "primaryGenre": "Finance",
          "genreId": "6015",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/0f/a0/6e/0fa06ec2-0029-986f-b5c9-ac203af56274/AppIcon-Production-0-0-1x_U007epad-0-1-85-220.png/100x100bb.png"
        },
        {
          "rank": 17,
          "trackId": 6451431247,
          "name": "Dola: Smart AI Assistant",
          "artistName": "SPRING(SG)PTE.LTD.",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a2/02/47/a2024767-459f-23dc-6aa5-9a312c7d595c/AppIcon-0-0-1x_U007epad-0-8-0-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 18,
          "trackId": 284815942,
          "name": "Google - More ways to search",
          "artistName": "Google",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/04/5e/47/045e4716-99d8-f058-1d82-b36131a7d3ae/SuperG_ios26-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-0-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 19,
          "trackId": 983156458,
          "name": "Microsoft Authenticator",
          "artistName": "Microsoft Corporation",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b6/a1/fc/b6a1fc21-1e74-4e0c-20c2-51a6cd2d65e9/AppIcon-0-1x_U007emarketing-0-11-0-sRGB-85-220-0.png/100x100bb.png"
        },
        {
          "rank": 20,
          "trackId": 504270602,
          "name": "Ryanair",
          "artistName": "Ryanair Ltd.",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/ed/f3/2f/edf32fc8-6180-8a99-b915-5d750d565802/AppIcon-0-0-1x_U007emarketing-0-6-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 21,
          "trackId": 1052238659,
          "name": "Monzo Bank - Mobile Banking",
          "artistName": "Monzo Bank Limited",
          "primaryGenre": "Finance",
          "genreId": "6015",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/02/ef/0d/02ef0d09-9398-eb13-8c36-42a6c922bc1d/AppIconProd-0-0-1x_U007ephone-0-1-0-0-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 22,
          "trackId": 519684662,
          "name": "bet365 - Sports Betting",
          "artistName": "Hillside Technology Limited",
          "primaryGenre": "Sports",
          "genreId": "6004",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/cf/3b/e6/cf3be668-b0ad-fd73-14b6-2bf50d3f2d57/AppIcon-0-0-1x_U007epad-0-1-0-sRGB-85-220.png/100x100bb.png"
        }
      ],
      "top-paid": [
        {
          "rank": 1,
          "trackId": 932747118,
          "name": "Shadowrocket",
          "artistName": "Shadow Launch Technology Limited",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d2/3a/31/d23a310a-0bce-973d-ba58-f051b99a6c64/AppIcon-0-0-1x_U007epad-0-1-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 2,
          "trackId": 373493387,
          "name": "AnkiMobile Flashcards",
          "artistName": "Anki Software, LLC",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/30/6b/da/306bdac5-3088-c97f-c682-e4626bfc6b43/AppIcon-0-0-1x_U007emarketing-0-5-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 3,
          "trackId": 916366645,
          "name": "Procreate Pocket",
          "artistName": "Savage Interactive Pty Ltd",
          "primaryGenre": "Graphics & Design",
          "genreId": "6027",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/d2/18/61/d2186101-9232-1bcf-251a-8ca543a12010/AppIcon-0-0-1x_U007emarketing-0-6-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 4,
          "trackId": 404990064,
          "name": "SkyView®",
          "artistName": "Terminal Eleven LLC",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/97/65/03/9765034e-0237-e438-3fa1-d4bdc65f5c8b/AppIcon-0-0-1x_U007emarketing-0-5-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 5,
          "trackId": 432850619,
          "name": "FL Studio Mobile",
          "artistName": "Image Line Software",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/81/2f/a2/812fa2f0-5147-e2fc-d2cb-421da0146685/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 6,
          "trackId": 578665578,
          "name": "Threema. The Secure Messenger",
          "artistName": "Threema GmbH",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/7a/68/fd/7a68fd73-cc8c-1de3-c6ae-541858bbce0e/AppIcon-0-0-1x_U007epad-0-0-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 7,
          "trackId": 904237743,
          "name": "Things 3",
          "artistName": "Cultured Code GmbH & Co. KG",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d0/1e/fe/d01efe6f-a09d-713e-0b02-b75c2865c215/AppIcon-0-0-1x_U007ephone-0-0-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 8,
          "trackId": 298206806,
          "name": "iReal Pro",
          "artistName": "Technimo LLC",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/4b/3e/dc/4b3edcfe-90fe-c207-f775-e75eba73ef2d/App_Icon-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 9,
          "trackId": 1633243177,
          "name": "Ableton Note",
          "artistName": "Ableton AG",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/62/b2/8d/62b28dc8-e7f7-58ca-5531-8878a1b54afa/AppIcon-1x_U007emarketing-0-8-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 10,
          "trackId": 577628510,
          "name": "TeamSpeak 3",
          "artistName": "TeamSpeak Systems Inc",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/98/33/e9/9833e9ee-fb56-df24-0ec1-d7eb12308d05/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 11,
          "trackId": 1062022008,
          "name": "LumaFusion",
          "artistName": "Luma Touch LLC",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a6/45/39/a64539ec-1521-9f96-fcd0-c7ac15a753ec/LumaFusionComposerIcon-0-1x_U007epad-0-1-0-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 12,
          "trackId": 596026805,
          "name": "PhotoPills",
          "artistName": "PhotoPills S.L.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/5e/60/70/5e60703c-75ac-14d2-ec12-bf81cee85008/Photopills-liquid-glass-logo-0-1x_U007epad-0-1-0-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 13,
          "trackId": 357421934,
          "name": "PeakFinder",
          "artistName": "PeakFinder GmbH",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/74/63/c4/7463c42f-333b-627b-8415-c6ba477d7aaa/AppIcon-0-0-1x_U007epad-0-1-0-P3-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 14,
          "trackId": 1303222868,
          "name": "Paprika Recipe Manager 3",
          "artistName": "Hindsight Labs LLC",
          "primaryGenre": "Food & Drink",
          "genreId": "6023",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/a0/11/fa/a011fa7f-a52b-e7f6-b376-5287cd7c281d/AppIcon-0-0-1x_U007emarketing-0-8-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 15,
          "trackId": 1164801111,
          "name": "AutoSleep: Watch Sleep Tracker",
          "artistName": "Tantsissa",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/fb/92/fa/fb92fadb-a7c2-0fc6-8fcf-082973492641/AppIcon-0-0-1x_U007ephone-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 16,
          "trackId": 1062745479,
          "name": "HeartWatch: Heart Rate Monitor",
          "artistName": "Tantsissa",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/bb/43/9a/bb439acd-67f8-8909-df62-eb65d3c246f0/AppIcon-0-0-1x_U007ephone-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 17,
          "trackId": 288419283,
          "name": "RadarScope",
          "artistName": "Base Velocity, LLC",
          "primaryGenre": "Weather",
          "genreId": "6001",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/30/88/a9/3088a97e-f8b7-b37a-f13c-0633b7c3cdba/App_Icon-0-0-1x_U007emarketing-0-0-0-8-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 18,
          "trackId": 497716362,
          "name": "TonalEnergy Tuner & Metronome",
          "artistName": "TonalEnergy, Inc",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/73/41/4b/73414b5f-0ab4-eb76-b031-5226e38337de/AppIcon-0-0-1x_U007emarketing-0-11-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 19,
          "trackId": 1241909999,
          "name": "WorkOutDoors",
          "artistName": "CCS Ltd",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b1/4b/02/b14b0228-1a44-ed1e-9d25-0e1c606f401a/AppIcon-0-0-1x_U007emarketing-0-6-0-0-GLES2_U002c0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 20,
          "trackId": 650684932,
          "name": "OBD Fusion",
          "artistName": "OCTech, LLC",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/60/8d/f8/608df835-24f9-efe5-7552-fe11a0222658/appicon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        }
      ],
      "top-grossing": [
        {
          "rank": 1,
          "trackId": 6448311069,
          "name": "ChatGPT",
          "artistName": "OpenAI OpCo, LLC",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/c7/eb/e6c7eb69-ade8-00b8-3454-d359249c6a0a/AppIcon-0-0-1x_U007epad-0-0-0-1-0-P3-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 2,
          "trackId": 835599320,
          "name": "TikTok - Videos, Music & LIVE",
          "artistName": "TikTok Ltd.",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/c8/cf/06/c8cf0625-604f-e6c1-575f-e49014356b5b/TikTok_AppIcon26-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 3,
          "trackId": 544007664,
          "name": "YouTube",
          "artistName": "Google",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/20/ea/87/20ea8738-6fac-caea-ccc1-72d8375a2310/logo_youtube_2024_q4_color-0-0-1x_U007emarketing-0-0-0-7-0-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 4,
          "trackId": 431946152,
          "name": "Roblox",
          "artistName": "Roblox Corporation",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/ac/a5/f6/aca5f69c-4a2e-44ea-9db2-7d87acf84b9d/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 5,
          "trackId": 1094591345,
          "name": "Pokémon GO",
          "artistName": "Niantic, Inc.",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b0/1d/a8/b01da803-6787-7011-bbb2-febab12f84de/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 6,
          "trackId": 6479970832,
          "name": "Pokémon TCG Pocket",
          "artistName": "The Pokemon Company",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/54/12/78/541278bd-ccac-156d-b027-a46e1cd536bb/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 7,
          "trackId": 553834731,
          "name": "Candy Crush Saga",
          "artistName": "King",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a1/c5/92/a1c59272-aace-ff82-0b16-ca93a87cb33c/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 8,
          "trackId": 529479190,
          "name": "Clash of Clans",
          "artistName": "Supercell",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/ed/78/c5/ed78c5e2-9a0b-fd1f-58fa-a51a50a283ed/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 9,
          "trackId": 1053012308,
          "name": "Clash Royale",
          "artistName": "Supercell",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/37/80/1e/37801e4c-717a-6d48-5023-5770fdbb2e01/AppIcon-0-0-1x_U007emarketing-0-7-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 10,
          "trackId": 1482155847,
          "name": "Royal Match",
          "artistName": "Dream Games",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/50/3d/ab/503dabf4-c381-e224-5630-5b031703c08d/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 11,
          "trackId": 1621328561,
          "name": "MONOPOLY GO!",
          "artistName": "Scopely, Inc.",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/35/63/c3/3563c36e-dc8f-45d4-1991-d9ab6db39557/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 12,
          "trackId": 324684580,
          "name": "Spotify: Music and Podcasts",
          "artistName": "Spotify",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d0/5c/0b/d05c0bcb-1d14-bf33-c74e-11518d8f245c/AppIcon-0-0-1x_U007epad-0-1-0-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 13,
          "trackId": 443904275,
          "name": "LINE",
          "artistName": "LINE Corporation",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/03/ce/cb/03cecbf9-9517-859d-b6c3-59afc3be6fd5/basic_default-0-0-1x_U007epad-0-6-0-0-sRGB-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 14,
          "trackId": 1500855883,
          "name": "CapCut: Photo & Video Editor",
          "artistName": "Bytedance Pte. Ltd",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/bb/37/1f/bb371fbb-68b3-a368-186d-947bfad8e540/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 15,
          "trackId": 547702041,
          "name": "Tinder Dating App: Meet & Date",
          "artistName": "Tinder LLC",
          "primaryGenre": "Lifestyle",
          "genreId": "6012",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/67/7b/27/677b27da-88b8-5b27-329a-eaedf9e07609/AppIcon-0-0-1x_U007emarketing-0-8-0-0-P3-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 16,
          "trackId": 985746746,
          "name": "Discord – Talk, Play, Hang Out",
          "artistName": "Discord Inc.",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/3c/fd/7d/3cfd7d5b-2976-2064-4023-c0bbfc4062ce/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 17,
          "trackId": 570060128,
          "name": "Duolingo: Language & Chess",
          "artistName": "Duolingo",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/35/31/5e/35315e16-db2f-e88d-1821-6a1b8f67d936/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 18,
          "trackId": 897446215,
          "name": "Canva: AI Video & Photo Editor",
          "artistName": "Canva",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/54/63/b5/5463b52f-ac99-4be1-6f74-fef35e4e3ce7/AppIcon-0-0-1x_U007epad-0-11-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 19,
          "trackId": 587366035,
          "name": "Picsart AI Photo Editor, Video",
          "artistName": "PicsArt, Inc.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/3f/78/a9/3f78a998-dbf1-a5d5-1bc7-6071a2183983/AppIcon-0-0-1x_U007emarketing-0-8-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 20,
          "trackId": 460177396,
          "name": "Twitch: Live Streaming",
          "artistName": "Twitch Interactive, Inc.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/df/b3/e6dfb315-9c80-4c32-e688-9d38cfabd6d6/TwitchAppIcon-0-0-1x_U007epad-0-1-0-0-0-0-85-220.png/100x100bb.jpg"
        }
      ]
    },
    "de": {
      "top-free": [
        {
          "rank": 1,
          "trackId": 1625657880,
          "name": "MagentaTV: TV & Streaming",
          "artistName": "Telekom Deutschland GmbH",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/70/91/9d/70919d22-8582-3b34-5c47-550852cb8fa6/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 3,
          "trackId": 6477489729,
          "name": "Google Gemini",
          "artistName": "Google",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/f7/dc/9e/f7dc9ef9-1731-1c66-7e00-ca58d011f1d9/AppIcon-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 4,
          "trackId": 6448311069,
          "name": "ChatGPT",
          "artistName": "OpenAI OpCo, LLC",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/c7/eb/e6c7eb69-ade8-00b8-3454-d359249c6a0a/AppIcon-0-0-1x_U007epad-0-0-0-1-0-P3-85-220.png/100x100bb.png"
        },
        {
          "rank": 5,
          "trackId": 570703120,
          "name": "Kicktipp",
          "artistName": "Kicktipp GmbH",
          "primaryGenre": "Sports",
          "genreId": "6004",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/b8/57/51/b8575185-5021-23e4-462a-93f115587b9c/AppIcon-0-0-1x_U007emarketing-0-11-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 6,
          "trackId": 1223471316,
          "name": "Shop: Deine Lieblingsmarken",
          "artistName": "Shopify Inc.",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/0f/19/a5/0f19a521-b043-ea18-ad89-ccb99efb0a8d/AppIcon-0-0-1x_U007ephone-0-11-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 7,
          "trackId": 719610089,
          "name": "CHECK24",
          "artistName": "CHECK24",
          "primaryGenre": "Finance",
          "genreId": "6015",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/67/e1/c0/67e1c074-e41e-1aed-409c-247394777e6c/AppIcon-0-0-1x_U007epad-0-1-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 8,
          "trackId": 329315203,
          "name": "Post & DHL",
          "artistName": "Deutsche Post AG",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/94/09/04/94090405-555b-8642-4ab3-c257b36b95fe/AppIcon.Prod-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 9,
          "trackId": 407932476,
          "name": "MeinMagenta: Handy & Festnetz",
          "artistName": "Telekom Deutschland GmbH",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/88/e4/8b/88e48b94-a96a-ce15-9db7-c5d0d892a2e8/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 10,
          "trackId": 6759037657,
          "name": "BA-Secure",
          "artistName": "Bundesagentur für Arbeit",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/70/a9/04/70a9042f-c689-186c-72ec-7e4fd9f3b724/AppIcon-Prod-0-0-1x_U007epad-0-1-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 11,
          "trackId": 948660805,
          "name": "AusweisApp Bund",
          "artistName": "Governikus GmbH & Co. KG",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/3e/30/9c/3e309c29-fbc3-75bf-5f38-8ad587543d79/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 12,
          "trackId": 925339063,
          "name": "Doctolib - Die Gesundheits-App",
          "artistName": "Doctolib",
          "primaryGenre": "Medical",
          "genreId": "6020",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/4d/6e/61/4d6e6182-3394-ab35-e405-84ea555214c1/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 13,
          "trackId": 449594317,
          "name": "EasyPark parken - Park App",
          "artistName": "Easy Park AS",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/79/91/71/79917162-6209-cb28-675c-6ed8c34e12b9/AppIcon-EP-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 14,
          "trackId": 437025413,
          "name": "ZDF",
          "artistName": "ZDF",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/33/a7/79/33a77915-81a7-1673-7c29-2a427559eea5/AppIcon-0-1x_U007epad-0-1-0-85-220-0.png/100x100bb.png"
        },
        {
          "rank": 15,
          "trackId": 368677368,
          "name": "Uber: Ride-Hailing & Taxis",
          "artistName": "Uber Technologies, Inc.",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/fc/90/8d/fc908dcb-c787-81a1-2189-524df4a82962/AppIcon-0-0-1x_U007emarketing-0-8-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 16,
          "trackId": 1186271926,
          "name": "Mein dm",
          "artistName": "dm-drogerie markt GmbH + Co. KG",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/4a/4d/bb/4a4dbb73-7f1c-3520-9f5f-79889e913659/AppIcon-0-0-1x_U007emarketing-0-6-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 17,
          "trackId": 585027354,
          "name": "Google Maps",
          "artistName": "Google",
          "primaryGenre": "Navigation",
          "genreId": "6010",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/06/26/aa/0626aaa5-0c1b-d7b7-598e-e2cb8a1f8523/maps_2025-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 18,
          "trackId": 914912959,
          "name": "MagentaSport - Dein Live-Sport",
          "artistName": "Telekom Deutschland GmbH",
          "primaryGenre": "Sports",
          "genreId": "6004",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/20/9c/f6/209cf68a-7d9e-82fe-c11f-d20f59329a69/AppIcon-0-0-1x_U007emarketing-0-11-0-0-0-0-GLES2_U002c0-85-220.png/100x100bb.png"
        },
        {
          "rank": 19,
          "trackId": 983156458,
          "name": "Microsoft Authenticator",
          "artistName": "Microsoft Corporation",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b6/a1/fc/b6a1fc21-1e74-4e0c-20c2-51a6cd2d65e9/AppIcon-0-1x_U007emarketing-0-11-0-sRGB-85-220-0.png/100x100bb.png"
        },
        {
          "rank": 20,
          "trackId": 1331065474,
          "name": "Nect Wallet",
          "artistName": "Nect",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/16/4b/18/164b18b3-a767-8b17-2746-9ef49d1ab051/AppIcon-0-1x_U007emarketing-0-8-0-85-220-0.png/100x100bb.png"
        },
        {
          "rank": 21,
          "trackId": 284815942,
          "name": "Google",
          "artistName": "Google",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/04/5e/47/045e4716-99d8-f058-1d82-b36131a7d3ae/SuperG_ios26-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-0-0-0-85-220.png/100x100bb.png"
        }
      ],
      "top-paid": [
        {
          "rank": 1,
          "trackId": 932747118,
          "name": "Shadowrocket",
          "artistName": "Shadow Launch Technology Limited",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d2/3a/31/d23a310a-0bce-973d-ba58-f051b99a6c64/AppIcon-0-0-1x_U007epad-0-1-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 2,
          "trackId": 373493387,
          "name": "AnkiMobile Flashcards",
          "artistName": "Anki Software, LLC",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/30/6b/da/306bdac5-3088-c97f-c682-e4626bfc6b43/AppIcon-0-0-1x_U007emarketing-0-5-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 3,
          "trackId": 916366645,
          "name": "Procreate Pocket",
          "artistName": "Savage Interactive Pty Ltd",
          "primaryGenre": "Graphics & Design",
          "genreId": "6027",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/d2/18/61/d2186101-9232-1bcf-251a-8ca543a12010/AppIcon-0-0-1x_U007emarketing-0-6-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 4,
          "trackId": 404990064,
          "name": "SkyView®",
          "artistName": "Terminal Eleven LLC",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/97/65/03/9765034e-0237-e438-3fa1-d4bdc65f5c8b/AppIcon-0-0-1x_U007emarketing-0-5-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 5,
          "trackId": 432850619,
          "name": "FL Studio Mobile",
          "artistName": "Image Line Software",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/81/2f/a2/812fa2f0-5147-e2fc-d2cb-421da0146685/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 6,
          "trackId": 578665578,
          "name": "Threema. Der sichere Messenger",
          "artistName": "Threema GmbH",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/7a/68/fd/7a68fd73-cc8c-1de3-c6ae-541858bbce0e/AppIcon-0-0-1x_U007epad-0-0-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 7,
          "trackId": 904237743,
          "name": "Things 3",
          "artistName": "Cultured Code GmbH & Co. KG",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d0/1e/fe/d01efe6f-a09d-713e-0b02-b75c2865c215/AppIcon-0-0-1x_U007ephone-0-0-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 8,
          "trackId": 298206806,
          "name": "iReal Pro",
          "artistName": "Technimo LLC",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/4b/3e/dc/4b3edcfe-90fe-c207-f775-e75eba73ef2d/App_Icon-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 9,
          "trackId": 1633243177,
          "name": "Ableton Note",
          "artistName": "Ableton AG",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/62/b2/8d/62b28dc8-e7f7-58ca-5531-8878a1b54afa/AppIcon-1x_U007emarketing-0-8-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 10,
          "trackId": 577628510,
          "name": "TeamSpeak 3",
          "artistName": "TeamSpeak Systems Inc",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/98/33/e9/9833e9ee-fb56-df24-0ec1-d7eb12308d05/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 11,
          "trackId": 1062022008,
          "name": "LumaFusion",
          "artistName": "Luma Touch LLC",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a6/45/39/a64539ec-1521-9f96-fcd0-c7ac15a753ec/LumaFusionComposerIcon-0-1x_U007epad-0-1-0-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 12,
          "trackId": 596026805,
          "name": "PhotoPills",
          "artistName": "PhotoPills S.L.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/5e/60/70/5e60703c-75ac-14d2-ec12-bf81cee85008/Photopills-liquid-glass-logo-0-1x_U007epad-0-1-0-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 13,
          "trackId": 357421934,
          "name": "PeakFinder",
          "artistName": "PeakFinder GmbH",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/74/63/c4/7463c42f-333b-627b-8415-c6ba477d7aaa/AppIcon-0-0-1x_U007epad-0-1-0-P3-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 14,
          "trackId": 1303222868,
          "name": "Paprika Rezept-Manager 3",
          "artistName": "Hindsight Labs LLC",
          "primaryGenre": "Food & Drink",
          "genreId": "6023",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/a0/11/fa/a011fa7f-a52b-e7f6-b376-5287cd7c281d/AppIcon-0-0-1x_U007emarketing-0-8-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 15,
          "trackId": 1164801111,
          "name": "AutoSleep - Schlaftracker",
          "artistName": "Tantsissa",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/fb/92/fa/fb92fadb-a7c2-0fc6-8fcf-082973492641/AppIcon-0-0-1x_U007ephone-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 16,
          "trackId": 1062745479,
          "name": "HeartWatch: Herzfrequenz",
          "artistName": "Tantsissa",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/bb/43/9a/bb439acd-67f8-8909-df62-eb65d3c246f0/AppIcon-0-0-1x_U007ephone-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 17,
          "trackId": 288419283,
          "name": "RadarScope",
          "artistName": "Base Velocity, LLC",
          "primaryGenre": "Weather",
          "genreId": "6001",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/30/88/a9/3088a97e-f8b7-b37a-f13c-0633b7c3cdba/App_Icon-0-0-1x_U007emarketing-0-0-0-8-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 18,
          "trackId": 497716362,
          "name": "TonalEnergy Stimmgerät & Metro",
          "artistName": "TonalEnergy, Inc",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/73/41/4b/73414b5f-0ab4-eb76-b031-5226e38337de/AppIcon-0-0-1x_U007emarketing-0-11-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 19,
          "trackId": 1241909999,
          "name": "WorkOutDoors",
          "artistName": "CCS Ltd",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b1/4b/02/b14b0228-1a44-ed1e-9d25-0e1c606f401a/AppIcon-0-0-1x_U007emarketing-0-6-0-0-GLES2_U002c0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 20,
          "trackId": 650684932,
          "name": "OBD Fusion",
          "artistName": "OCTech, LLC",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/60/8d/f8/608df835-24f9-efe5-7552-fe11a0222658/appicon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        }
      ],
      "top-grossing": [
        {
          "rank": 1,
          "trackId": 6448311069,
          "name": "ChatGPT",
          "artistName": "OpenAI OpCo, LLC",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/c7/eb/e6c7eb69-ade8-00b8-3454-d359249c6a0a/AppIcon-0-0-1x_U007epad-0-0-0-1-0-P3-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 2,
          "trackId": 835599320,
          "name": "TikTok - Videos, Shop und LIVE",
          "artistName": "TikTok Ltd.",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/c8/cf/06/c8cf0625-604f-e6c1-575f-e49014356b5b/TikTok_AppIcon26-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 3,
          "trackId": 544007664,
          "name": "YouTube",
          "artistName": "Google",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/20/ea/87/20ea8738-6fac-caea-ccc1-72d8375a2310/logo_youtube_2024_q4_color-0-0-1x_U007emarketing-0-0-0-7-0-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 4,
          "trackId": 431946152,
          "name": "Roblox",
          "artistName": "Roblox Corporation",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/ac/a5/f6/aca5f69c-4a2e-44ea-9db2-7d87acf84b9d/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 5,
          "trackId": 1094591345,
          "name": "Pokémon GO",
          "artistName": "Niantic, Inc.",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b0/1d/a8/b01da803-6787-7011-bbb2-febab12f84de/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 6,
          "trackId": 6479970832,
          "name": "Pokémon TCG Pocket",
          "artistName": "The Pokemon Company",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/54/12/78/541278bd-ccac-156d-b027-a46e1cd536bb/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 7,
          "trackId": 553834731,
          "name": "Candy Crush Saga",
          "artistName": "King",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a1/c5/92/a1c59272-aace-ff82-0b16-ca93a87cb33c/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 8,
          "trackId": 529479190,
          "name": "Clash of Clans",
          "artistName": "Supercell",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/ed/78/c5/ed78c5e2-9a0b-fd1f-58fa-a51a50a283ed/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 9,
          "trackId": 1053012308,
          "name": "Clash Royale",
          "artistName": "Supercell",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/37/80/1e/37801e4c-717a-6d48-5023-5770fdbb2e01/AppIcon-0-0-1x_U007emarketing-0-7-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 10,
          "trackId": 1482155847,
          "name": "Royal Match",
          "artistName": "Dream Games",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/50/3d/ab/503dabf4-c381-e224-5630-5b031703c08d/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 11,
          "trackId": 1621328561,
          "name": "MONOPOLY GO!",
          "artistName": "Scopely, Inc.",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/35/63/c3/3563c36e-dc8f-45d4-1991-d9ab6db39557/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 12,
          "trackId": 324684580,
          "name": "Spotify Musik und Podcasts",
          "artistName": "Spotify",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d0/5c/0b/d05c0bcb-1d14-bf33-c74e-11518d8f245c/AppIcon-0-0-1x_U007epad-0-1-0-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 13,
          "trackId": 443904275,
          "name": "LINE",
          "artistName": "LINE Corporation",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/03/ce/cb/03cecbf9-9517-859d-b6c3-59afc3be6fd5/basic_default-0-0-1x_U007epad-0-6-0-0-sRGB-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 14,
          "trackId": 1500855883,
          "name": "CapCut: Foto- und Video-Editor",
          "artistName": "Bytedance Pte. Ltd",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/bb/37/1f/bb371fbb-68b3-a368-186d-947bfad8e540/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 15,
          "trackId": 547702041,
          "name": "Tinder Dating App: Chat & Date",
          "artistName": "Tinder LLC",
          "primaryGenre": "Lifestyle",
          "genreId": "6012",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/67/7b/27/677b27da-88b8-5b27-329a-eaedf9e07609/AppIcon-0-0-1x_U007emarketing-0-8-0-0-P3-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 16,
          "trackId": 985746746,
          "name": "Discord: Reden, Gamen, Chillen",
          "artistName": "Discord Inc.",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/3c/fd/7d/3cfd7d5b-2976-2064-4023-c0bbfc4062ce/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 17,
          "trackId": 570060128,
          "name": "Duolingo: Sprachen und Schach",
          "artistName": "Duolingo",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/35/31/5e/35315e16-db2f-e88d-1821-6a1b8f67d936/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 18,
          "trackId": 897446215,
          "name": "Canva: KI-Foto- & Video-Editor",
          "artistName": "Canva",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/54/63/b5/5463b52f-ac99-4be1-6f74-fef35e4e3ce7/AppIcon-0-0-1x_U007epad-0-11-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 19,
          "trackId": 587366035,
          "name": "Picsart: KI Bilder bearbeiten",
          "artistName": "PicsArt, Inc.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/3f/78/a9/3f78a998-dbf1-a5d5-1bc7-6071a2183983/AppIcon-0-0-1x_U007emarketing-0-8-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 20,
          "trackId": 460177396,
          "name": "Twitch: Live-Streaming",
          "artistName": "Twitch Interactive, Inc.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/df/b3/e6dfb315-9c80-4c32-e688-9d38cfabd6d6/TwitchAppIcon-0-0-1x_U007epad-0-1-0-0-0-0-85-220.png/100x100bb.jpg"
        }
      ]
    },
    "br": {
      "top-free": [
        {
          "rank": 1,
          "trackId": 6448311069,
          "name": "ChatGPT",
          "artistName": "OpenAI OpCo, LLC",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/c7/eb/e6c7eb69-ade8-00b8-3454-d359249c6a0a/AppIcon-0-0-1x_U007epad-0-0-0-1-0-P3-85-220.png/100x100bb.png"
        },
        {
          "rank": 2,
          "trackId": 1590532471,
          "name": "bet365 - Apostas Esportivas",
          "artistName": "Hillside Technology Limited",
          "primaryGenre": "Sports",
          "genreId": "6004",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/dc/bd/67/dcbd67e1-8533-97cf-e07e-b6060e39a43e/AppIcon-0-0-1x_U007epad-0-1-0-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 3,
          "trackId": 6754835780,
          "name": "Betano – Apostas e Cassino",
          "artistName": "Kaizen Gaming Brasil Ltda",
          "primaryGenre": "Sports",
          "genreId": "6004",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/60/df/39/60df39d0-3ea3-4e2c-e453-0290cba61c01/AppIconWC26-0-0-1x_U007epad-0-1-0-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 4,
          "trackId": 1641486558,
          "name": "Temu: Compre como bilionário",
          "artistName": "Temu",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/d1/cf/30/d1cf3071-76fb-6fc5-673f-3a6c381fbd98/AppIcon-0-1x_U007epad-0-1-0-0-85-220-0.png/100x100bb.png"
        },
        {
          "rank": 5,
          "trackId": 6477489729,
          "name": "Google Gemini",
          "artistName": "Google",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/f7/dc/9e/f7dc9ef9-1731-1c66-7e00-ca58d011f1d9/AppIcon-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 6,
          "trackId": 463624852,
          "name": "Mercado Livre: Compras Online",
          "artistName": "MercadoLibre",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/3c/63/17/3c6317df-e35d-34ab-58db-edaf547dffc4/AppIcon-0-0-1x_U007emarketing-0-6-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 7,
          "trackId": 6446788829,
          "name": "Apple Sports",
          "artistName": "Apple",
          "primaryGenre": "Sports",
          "genreId": "6004",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/00/05/79/00057923-40fd-ff12-e2b1-ce49eddaaf24/AppIcon-0-1x_U007ephone-0-0-0-1-0-P3-0-85-220-0.png/100x100bb.png"
        },
        {
          "rank": 8,
          "trackId": 1506827551,
          "name": "gov.br",
          "artistName": "Servicos e Informacoes do Brasil",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/68/95/6f/68956f5d-455d-b92e-9b1c-d910fae8b073/AppIcon-0-0-1x_U007emarketing-0-11-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 9,
          "trackId": 6447582581,
          "name": "Netflix Game Controller",
          "artistName": "Netflix, Inc.",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/22/03/21/22032103-e65c-2bea-9a13-0fa2e791f0d9/AppIcon-0-0-1x_U007epad-0-1-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 10,
          "trackId": 6738967378,
          "name": "Edits: Editor de Vídeo",
          "artistName": "Instagram, Inc.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/c8/57/13/c857131e-da8d-3cce-2059-0068f1d5df32/Prod-0-0-1x_U007ephone-0-0-0-1-0-0-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 11,
          "trackId": 436672029,
          "name": "AliExpress Shopping App",
          "artistName": "Alibaba",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/07/38/b1/0738b141-101c-a30e-062a-25f47a4e0bc0/AppIcon-0-0-1x_U007epad-0-1-0-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 12,
          "trackId": 1481812175,
          "name": "Shopee: 7.7 Aniversário",
          "artistName": "SHPS I Private Limited",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/c0/df/dc/c0dfdc6d-e520-54ed-55df-860bc9a69f18/AppIcon-0-0-1x_U007emarketing-0-6-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 13,
          "trackId": 925436649,
          "name": "Mercado Pago: banco digital",
          "artistName": "MercadoLibre",
          "primaryGenre": "Finance",
          "genreId": "6015",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/ae/aa/7a/aeaa7a04-de5f-3668-6672-0504ecfebfc1/App_Icon-0-0-1x_U007emarketing-0-6-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 14,
          "trackId": 6446901002,
          "name": "Threads",
          "artistName": "Instagram, Inc.",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/a0/72/07/a07207e3-9102-3699-30db-9a086554ffd3/Prod-0-0-1x_U007ephone-0-0-0-1-0-0-P3-85-220.png/100x100bb.png"
        },
        {
          "rank": 15,
          "trackId": 1500855883,
          "name": "CapCut - Editor de vídeo",
          "artistName": "Bytedance Pte. Ltd",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/bb/37/1f/bb371fbb-68b3-a368-186d-947bfad8e540/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 16,
          "trackId": 878577184,
          "name": "SHEIN - Compras Online",
          "artistName": "ROADGET BUSINESS PTE. LTD.",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/8b/07/37/8b073752-3a57-cfa4-ded6-3f35414d05e7/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 17,
          "trackId": 585027354,
          "name": "Google Maps",
          "artistName": "Google",
          "primaryGenre": "Navigation",
          "genreId": "6010",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/06/26/aa/0626aaa5-0c1b-d7b7-598e-e2cb8a1f8523/maps_2025-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 18,
          "trackId": 6451431247,
          "name": "Dola: assist. inteligente (IA)",
          "artistName": "SPRING(SG)PTE.LTD.",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a2/02/47/a2024767-459f-23dc-6aa5-9a312c7d595c/AppIcon-0-0-1x_U007epad-0-8-0-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 19,
          "trackId": 1275057217,
          "name": "CNH do Brasil",
          "artistName": "Servicos e Informacoes do Brasil",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/08/36/f6/0836f6e6-6959-02c1-a548-4991e5bfc3d6/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 20,
          "trackId": 553663691,
          "name": "99: Corridas, Food, Pay",
          "artistName": "99 Taxis Desenvolvimento de Softwares Ltda. - Epp",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b0/30/dc/b030dcba-4026-54b2-348a-6459ab66fcbe/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.png"
        }
      ],
      "top-paid": [
        {
          "rank": 1,
          "trackId": 932747118,
          "name": "Shadowrocket",
          "artistName": "Shadow Launch Technology Limited",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d2/3a/31/d23a310a-0bce-973d-ba58-f051b99a6c64/AppIcon-0-0-1x_U007epad-0-1-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 2,
          "trackId": 373493387,
          "name": "AnkiMobile Flashcards",
          "artistName": "Anki Software, LLC",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/30/6b/da/306bdac5-3088-c97f-c682-e4626bfc6b43/AppIcon-0-0-1x_U007emarketing-0-5-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 3,
          "trackId": 916366645,
          "name": "Procreate Pocket",
          "artistName": "Savage Interactive Pty Ltd",
          "primaryGenre": "Graphics & Design",
          "genreId": "6027",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/d2/18/61/d2186101-9232-1bcf-251a-8ca543a12010/AppIcon-0-0-1x_U007emarketing-0-6-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 4,
          "trackId": 404990064,
          "name": "SkyView®",
          "artistName": "Terminal Eleven LLC",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/97/65/03/9765034e-0237-e438-3fa1-d4bdc65f5c8b/AppIcon-0-0-1x_U007emarketing-0-5-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 5,
          "trackId": 432850619,
          "name": "FL Studio Mobile",
          "artistName": "Image Line Software",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/81/2f/a2/812fa2f0-5147-e2fc-d2cb-421da0146685/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 6,
          "trackId": 578665578,
          "name": "Threema. Messenger seguro",
          "artistName": "Threema GmbH",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/7a/68/fd/7a68fd73-cc8c-1de3-c6ae-541858bbce0e/AppIcon-0-0-1x_U007epad-0-0-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 7,
          "trackId": 904237743,
          "name": "Things 3",
          "artistName": "Cultured Code GmbH & Co. KG",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d0/1e/fe/d01efe6f-a09d-713e-0b02-b75c2865c215/AppIcon-0-0-1x_U007ephone-0-0-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 8,
          "trackId": 298206806,
          "name": "iReal Pro",
          "artistName": "Technimo LLC",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/4b/3e/dc/4b3edcfe-90fe-c207-f775-e75eba73ef2d/App_Icon-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 9,
          "trackId": 1633243177,
          "name": "Ableton Note",
          "artistName": "Ableton AG",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/62/b2/8d/62b28dc8-e7f7-58ca-5531-8878a1b54afa/AppIcon-1x_U007emarketing-0-8-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 10,
          "trackId": 577628510,
          "name": "TeamSpeak 3",
          "artistName": "TeamSpeak Systems Inc",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/98/33/e9/9833e9ee-fb56-df24-0ec1-d7eb12308d05/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 11,
          "trackId": 1062022008,
          "name": "LumaFusion",
          "artistName": "Luma Touch LLC",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a6/45/39/a64539ec-1521-9f96-fcd0-c7ac15a753ec/LumaFusionComposerIcon-0-1x_U007epad-0-1-0-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 12,
          "trackId": 596026805,
          "name": "PhotoPills",
          "artistName": "PhotoPills S.L.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/5e/60/70/5e60703c-75ac-14d2-ec12-bf81cee85008/Photopills-liquid-glass-logo-0-1x_U007epad-0-1-0-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 13,
          "trackId": 357421934,
          "name": "PeakFinder",
          "artistName": "PeakFinder GmbH",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/74/63/c4/7463c42f-333b-627b-8415-c6ba477d7aaa/AppIcon-0-0-1x_U007epad-0-1-0-P3-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 14,
          "trackId": 1303222868,
          "name": "Gestor de Receitas Paprika 3",
          "artistName": "Hindsight Labs LLC",
          "primaryGenre": "Food & Drink",
          "genreId": "6023",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/a0/11/fa/a011fa7f-a52b-e7f6-b376-5287cd7c281d/AppIcon-0-0-1x_U007emarketing-0-8-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 15,
          "trackId": 1164801111,
          "name": "AutoSleep – Rastreador de sono",
          "artistName": "Tantsissa",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/fb/92/fa/fb92fadb-a7c2-0fc6-8fcf-082973492641/AppIcon-0-0-1x_U007ephone-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 16,
          "trackId": 1062745479,
          "name": "HeartWatch: Monitor Frequência",
          "artistName": "Tantsissa",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/bb/43/9a/bb439acd-67f8-8909-df62-eb65d3c246f0/AppIcon-0-0-1x_U007ephone-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 17,
          "trackId": 288419283,
          "name": "RadarScope",
          "artistName": "Base Velocity, LLC",
          "primaryGenre": "Weather",
          "genreId": "6001",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/30/88/a9/3088a97e-f8b7-b37a-f13c-0633b7c3cdba/App_Icon-0-0-1x_U007emarketing-0-0-0-8-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 18,
          "trackId": 497716362,
          "name": "TonalEnergy Afinador+Metrônomo",
          "artistName": "TonalEnergy, Inc",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/73/41/4b/73414b5f-0ab4-eb76-b031-5226e38337de/AppIcon-0-0-1x_U007emarketing-0-11-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 19,
          "trackId": 1241909999,
          "name": "WorkOutDoors",
          "artistName": "CCS Ltd",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b1/4b/02/b14b0228-1a44-ed1e-9d25-0e1c606f401a/AppIcon-0-0-1x_U007emarketing-0-6-0-0-GLES2_U002c0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 20,
          "trackId": 650684932,
          "name": "OBD Fusion",
          "artistName": "OCTech, LLC",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/60/8d/f8/608df835-24f9-efe5-7552-fe11a0222658/appicon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        }
      ],
      "top-grossing": [
        {
          "rank": 1,
          "trackId": 6448311069,
          "name": "ChatGPT",
          "artistName": "OpenAI OpCo, LLC",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/c7/eb/e6c7eb69-ade8-00b8-3454-d359249c6a0a/AppIcon-0-0-1x_U007epad-0-0-0-1-0-P3-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 2,
          "trackId": 835599320,
          "name": "TikTok: Vídeos, Músicas & LIVE",
          "artistName": "TikTok Ltd.",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/c8/cf/06/c8cf0625-604f-e6c1-575f-e49014356b5b/TikTok_AppIcon26-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 3,
          "trackId": 544007664,
          "name": "YouTube",
          "artistName": "Google",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/20/ea/87/20ea8738-6fac-caea-ccc1-72d8375a2310/logo_youtube_2024_q4_color-0-0-1x_U007emarketing-0-0-0-7-0-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 4,
          "trackId": 431946152,
          "name": "Roblox",
          "artistName": "Roblox Corporation",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/ac/a5/f6/aca5f69c-4a2e-44ea-9db2-7d87acf84b9d/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 5,
          "trackId": 1094591345,
          "name": "Pokémon GO",
          "artistName": "Niantic, Inc.",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b0/1d/a8/b01da803-6787-7011-bbb2-febab12f84de/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 6,
          "trackId": 6479970832,
          "name": "Pokémon TCG Pocket",
          "artistName": "The Pokemon Company",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/54/12/78/541278bd-ccac-156d-b027-a46e1cd536bb/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 7,
          "trackId": 553834731,
          "name": "Candy Crush Saga",
          "artistName": "King",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a1/c5/92/a1c59272-aace-ff82-0b16-ca93a87cb33c/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 8,
          "trackId": 529479190,
          "name": "Clash of Clans",
          "artistName": "Supercell",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/ed/78/c5/ed78c5e2-9a0b-fd1f-58fa-a51a50a283ed/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 9,
          "trackId": 1053012308,
          "name": "Clash Royale",
          "artistName": "Supercell",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/37/80/1e/37801e4c-717a-6d48-5023-5770fdbb2e01/AppIcon-0-0-1x_U007emarketing-0-7-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 10,
          "trackId": 1482155847,
          "name": "Royal Match",
          "artistName": "Dream Games",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/50/3d/ab/503dabf4-c381-e224-5630-5b031703c08d/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 11,
          "trackId": 1621328561,
          "name": "MONOPOLY GO!",
          "artistName": "Scopely, Inc.",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/35/63/c3/3563c36e-dc8f-45d4-1991-d9ab6db39557/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 12,
          "trackId": 324684580,
          "name": "Spotify: músicas e podcasts",
          "artistName": "Spotify",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d0/5c/0b/d05c0bcb-1d14-bf33-c74e-11518d8f245c/AppIcon-0-0-1x_U007epad-0-1-0-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 13,
          "trackId": 443904275,
          "name": "LINE",
          "artistName": "LINE Corporation",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/03/ce/cb/03cecbf9-9517-859d-b6c3-59afc3be6fd5/basic_default-0-0-1x_U007epad-0-6-0-0-sRGB-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 14,
          "trackId": 1500855883,
          "name": "CapCut - Editor de vídeo",
          "artistName": "Bytedance Pte. Ltd",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/bb/37/1f/bb371fbb-68b3-a368-186d-947bfad8e540/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 15,
          "trackId": 547702041,
          "name": "Tinder - app de relacionamento",
          "artistName": "Tinder LLC",
          "primaryGenre": "Lifestyle",
          "genreId": "6012",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/67/7b/27/677b27da-88b8-5b27-329a-eaedf9e07609/AppIcon-0-0-1x_U007emarketing-0-8-0-0-P3-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 16,
          "trackId": 985746746,
          "name": "Discord - Converse e Jogue",
          "artistName": "Discord Inc.",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/3c/fd/7d/3cfd7d5b-2976-2064-4023-c0bbfc4062ce/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 17,
          "trackId": 570060128,
          "name": "Duolingo – Aprenda idiomas",
          "artistName": "Duolingo",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/35/31/5e/35315e16-db2f-e88d-1821-6a1b8f67d936/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 18,
          "trackId": 897446215,
          "name": "Canva: editor de fotos e vídeo",
          "artistName": "Canva",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/54/63/b5/5463b52f-ac99-4be1-6f74-fef35e4e3ce7/AppIcon-0-0-1x_U007epad-0-11-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 19,
          "trackId": 587366035,
          "name": "Picsart: Editor de Fotos IA",
          "artistName": "PicsArt, Inc.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/3f/78/a9/3f78a998-dbf1-a5d5-1bc7-6071a2183983/AppIcon-0-0-1x_U007emarketing-0-8-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 20,
          "trackId": 460177396,
          "name": "Twitch: Transmissão ao vivo",
          "artistName": "Twitch Interactive, Inc.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/df/b3/e6dfb315-9c80-4c32-e688-9d38cfabd6d6/TwitchAppIcon-0-0-1x_U007epad-0-1-0-0-0-0-85-220.png/100x100bb.jpg"
        }
      ]
    },
    "kr": {
      "top-free": [
        {
          "rank": 1,
          "trackId": 1585297308,
          "name": "치지직",
          "artistName": "NAVER Corp.",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/5c/af/6f/5caf6ffa-33cb-6d0b-85cb-2319eef125f9/AppIcon-0-0-1x_U007epad-0-1-0-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 2,
          "trackId": 6477489729,
          "name": "Google Gemini",
          "artistName": "Google",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/f7/dc/9e/f7dc9ef9-1731-1c66-7e00-ca58d011f1d9/AppIcon-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 3,
          "trackId": 379577046,
          "name": "monimo(삼성금융통합앱)생명 화재 카드 증권 모니모",
          "artistName": "Samsungcard Co., Ltd.",
          "primaryGenre": "Finance",
          "genreId": "6015",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b4/a1/66/b4a16682-ce9d-18f8-b9f1-dbd74a109af0/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 4,
          "trackId": 6743190232,
          "name": "하나은행, 새로워진 하나원큐를 경험해 보세요",
          "artistName": "Hana Bank",
          "primaryGenre": "Finance",
          "genreId": "6015",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/fb/0c/6b/fb0c6b29-ff76-1151-8870-3f5ff0d39b8b/AppIcon-0-0-1x_U007ephone-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 7,
          "trackId": 535074178,
          "name": "JTBC NOW",
          "artistName": "JTBC",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/41/c4/90/41c49061-9e03-e16a-1cdf-7379b773e5a5/AppIcon-0-0-1x_U007ephone-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 8,
          "trackId": 6504849169,
          "name": "NetShort - 인기 드라마 및 TV 프로그램",
          "artistName": "NETSTORY PTE. LTD.",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/89/9f/52/899f5206-e79a-9e76-fda5-a5f714853a6b/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 9,
          "trackId": 6738063154,
          "name": "네이버플러스 스토어",
          "artistName": "NAVER Corp.",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/1b/8e/dc/1b8edc50-1979-ab30-7dbe-63fe336ad22c/AppIcon-0-0-1x_U007ephone-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 10,
          "trackId": 1150231646,
          "name": "삼성증권 mPOP",
          "artistName": "SAMSUNG SECURITIES Co., LTD.",
          "primaryGenre": "Finance",
          "genreId": "6015",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/dc/c0/e5/dcc0e528-96b5-3f64-a630-345b67bf2b22/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 11,
          "trackId": 1599450372,
          "name": "대한민국 모바일 신분증",
          "artistName": "행정안전부",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/8f/6a/2d/8f6a2daa-5af2-f600-3e7f-6a54dab280d7/AppIcon-0-0-1x_U007ephone-0-11-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 12,
          "trackId": 357484932,
          "name": "신한 슈퍼SOL - 신한 유니버셜 금융 앱",
          "artistName": "SHINHAN BANK",
          "primaryGenre": "Finance",
          "genreId": "6015",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/3a/94/18/3a9418fe-da94-6c6c-824d-a878cca5a958/AppIcon-0-0-1x_U007ephone-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 13,
          "trackId": 6448311069,
          "name": "ChatGPT",
          "artistName": "OpenAI OpCo, LLC",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/c7/eb/e6c7eb69-ade8-00b8-3454-d359249c6a0a/AppIcon-0-0-1x_U007epad-0-0-0-1-0-P3-85-220.png/100x100bb.png"
        },
        {
          "rank": 14,
          "trackId": 1554807824,
          "name": "네이버페이",
          "artistName": "Naver Financial Corporation",
          "primaryGenre": "Finance",
          "genreId": "6015",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/fc/fb/41/fcfb4192-1bf1-e0ec-7754-b0969a0f1540/AppIcon-0-0-1x_U007emarketing-0-8-0-sRGB-85-220.png/100x100bb.png"
        },
        {
          "rank": 15,
          "trackId": 1163786766,
          "name": "알라미 - 무조건 깨워주는 알람 시계",
          "artistName": "Delight Room Co., Ltd.",
          "primaryGenre": "Lifestyle",
          "genreId": "6012",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/b8/50/2c/b8502c93-2333-72c4-e968-b91c1a2e3736/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.png"
        },
        {
          "rank": 16,
          "trackId": 6444602589,
          "name": "모바일 건강보험증",
          "artistName": "국민건강보험공단",
          "primaryGenre": "Medical",
          "genreId": "6020",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/88/e2/0d/88e20d29-31ad-cae6-897d-b5722b04c8b7/AppIcon-0-0-1x_U007emarketing-0-6-0-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 17,
          "trackId": 1003139529,
          "name": "온라인 패션 스토어 무신사",
          "artistName": "MUSINSA Co.,Ltd",
          "primaryGenre": "Shopping",
          "genreId": "6024",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/03/e1/1c/03e11c11-e7d5-dd4f-9569-4615fe193e8d/iOS26Appicon-0-0-1x_U007epad-0-1-P3-85-220.png/100x100bb.png"
        },
        {
          "rank": 18,
          "trackId": 1222822904,
          "name": "SmartThings",
          "artistName": "Samsung Electronics Co., Ltd.",
          "primaryGenre": "Lifestyle",
          "genreId": "6012",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/78/51/fa/7851fa22-fb65-df69-dc43-f40d7d72c0ac/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 19,
          "trackId": 1538531939,
          "name": "K-패스",
          "artistName": "교통안전공단",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/22/1f/13/221f137a-2c68-e7d7-41cf-d0425830a9ce/AppIcon-0-0-1x_U007emarketing-0-10-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 20,
          "trackId": 6446901002,
          "name": "Threads",
          "artistName": "Instagram, Inc.",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/a0/72/07/a07207e3-9102-3699-30db-9a086554ffd3/Prod-0-0-1x_U007ephone-0-0-0-1-0-0-P3-85-220.png/100x100bb.png"
        },
        {
          "rank": 21,
          "trackId": 1248716281,
          "name": "미래에셋증권 M-STOCK",
          "artistName": "Mirae Asset Securities Co., Ltd.",
          "primaryGenre": "Finance",
          "genreId": "6015",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/68/30/11/683011cf-f734-c6a3-f69d-1061c086e0d1/AppIcon-0-0-1x_U007emarketing-0-7-0-85-220.png/100x100bb.png"
        },
        {
          "rank": 22,
          "trackId": 570060128,
          "name": "듀오링고(Duolingo): 언어 학습",
          "artistName": "Duolingo",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/35/31/5e/35315e16-db2f-e88d-1821-6a1b8f67d936/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.png"
        }
      ],
      "top-paid": [
        {
          "rank": 1,
          "trackId": 932747118,
          "name": "Shadowrocket",
          "artistName": "Shadow Launch Technology Limited",
          "primaryGenre": "Utilities",
          "genreId": "6002",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d2/3a/31/d23a310a-0bce-973d-ba58-f051b99a6c64/AppIcon-0-0-1x_U007epad-0-1-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 2,
          "trackId": 373493387,
          "name": "AnkiMobile Flashcards",
          "artistName": "Anki Software, LLC",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/30/6b/da/306bdac5-3088-c97f-c682-e4626bfc6b43/AppIcon-0-0-1x_U007emarketing-0-5-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 3,
          "trackId": 916366645,
          "name": "Procreate Pocket",
          "artistName": "Savage Interactive Pty Ltd",
          "primaryGenre": "Graphics & Design",
          "genreId": "6027",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/d2/18/61/d2186101-9232-1bcf-251a-8ca543a12010/AppIcon-0-0-1x_U007emarketing-0-6-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 4,
          "trackId": 404990064,
          "name": "SkyView®",
          "artistName": "Terminal Eleven LLC",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/97/65/03/9765034e-0237-e438-3fa1-d4bdc65f5c8b/AppIcon-0-0-1x_U007emarketing-0-5-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 5,
          "trackId": 432850619,
          "name": "FL Studio Mobile",
          "artistName": "Image Line Software",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/81/2f/a2/812fa2f0-5147-e2fc-d2cb-421da0146685/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 6,
          "trackId": 578665578,
          "name": "Threema. The Secure Messenger",
          "artistName": "Threema GmbH",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/7a/68/fd/7a68fd73-cc8c-1de3-c6ae-541858bbce0e/AppIcon-0-0-1x_U007epad-0-0-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 7,
          "trackId": 904237743,
          "name": "Things 3",
          "artistName": "Cultured Code GmbH & Co. KG",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d0/1e/fe/d01efe6f-a09d-713e-0b02-b75c2865c215/AppIcon-0-0-1x_U007ephone-0-0-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 8,
          "trackId": 298206806,
          "name": "iReal Pro",
          "artistName": "Technimo LLC",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/4b/3e/dc/4b3edcfe-90fe-c207-f775-e75eba73ef2d/App_Icon-0-0-1x_U007epad-0-0-0-1-0-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 9,
          "trackId": 1633243177,
          "name": "Ableton Note",
          "artistName": "Ableton AG",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/62/b2/8d/62b28dc8-e7f7-58ca-5531-8878a1b54afa/AppIcon-1x_U007emarketing-0-8-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 10,
          "trackId": 577628510,
          "name": "TeamSpeak 3",
          "artistName": "TeamSpeak Systems Inc",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/98/33/e9/9833e9ee-fb56-df24-0ec1-d7eb12308d05/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 11,
          "trackId": 1062022008,
          "name": "LumaFusion",
          "artistName": "Luma Touch LLC",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a6/45/39/a64539ec-1521-9f96-fcd0-c7ac15a753ec/LumaFusionComposerIcon-0-1x_U007epad-0-1-0-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 12,
          "trackId": 596026805,
          "name": "PhotoPills",
          "artistName": "PhotoPills S.L.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/5e/60/70/5e60703c-75ac-14d2-ec12-bf81cee85008/Photopills-liquid-glass-logo-0-1x_U007epad-0-1-0-0-85-220-0.png/100x100bb.jpg"
        },
        {
          "rank": 13,
          "trackId": 357421934,
          "name": "PeakFinder",
          "artistName": "PeakFinder GmbH",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/74/63/c4/7463c42f-333b-627b-8415-c6ba477d7aaa/AppIcon-0-0-1x_U007epad-0-1-0-P3-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 14,
          "trackId": 1303222868,
          "name": "Paprika Recipe Manager 3",
          "artistName": "Hindsight Labs LLC",
          "primaryGenre": "Food & Drink",
          "genreId": "6023",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/a0/11/fa/a011fa7f-a52b-e7f6-b376-5287cd7c281d/AppIcon-0-0-1x_U007emarketing-0-8-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 15,
          "trackId": 1164801111,
          "name": "AutoSleep - Watch를 이용한 수면 분석",
          "artistName": "Tantsissa",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/fb/92/fa/fb92fadb-a7c2-0fc6-8fcf-082973492641/AppIcon-0-0-1x_U007ephone-0-1-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 16,
          "trackId": 1062745479,
          "name": "HeartWatch: 심박수 모니터링",
          "artistName": "Tantsissa",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/bb/43/9a/bb439acd-67f8-8909-df62-eb65d3c246f0/AppIcon-0-0-1x_U007ephone-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 17,
          "trackId": 288419283,
          "name": "RadarScope",
          "artistName": "Base Velocity, LLC",
          "primaryGenre": "Weather",
          "genreId": "6001",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/30/88/a9/3088a97e-f8b7-b37a-f13c-0633b7c3cdba/App_Icon-0-0-1x_U007emarketing-0-0-0-8-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 18,
          "trackId": 497716362,
          "name": "TonalEnergy Tuner & Metronome",
          "artistName": "TonalEnergy, Inc",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/73/41/4b/73414b5f-0ab4-eb76-b031-5226e38337de/AppIcon-0-0-1x_U007emarketing-0-11-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 19,
          "trackId": 1241909999,
          "name": "WorkOutDoors",
          "artistName": "CCS Ltd",
          "primaryGenre": "Health & Fitness",
          "genreId": "6013",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b1/4b/02/b14b0228-1a44-ed1e-9d25-0e1c606f401a/AppIcon-0-0-1x_U007emarketing-0-6-0-0-GLES2_U002c0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 20,
          "trackId": 650684932,
          "name": "OBD Fusion",
          "artistName": "OCTech, LLC",
          "primaryGenre": "Travel",
          "genreId": "6003",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/60/8d/f8/608df835-24f9-efe5-7552-fe11a0222658/appicon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        }
      ],
      "top-grossing": [
        {
          "rank": 1,
          "trackId": 6448311069,
          "name": "ChatGPT",
          "artistName": "OpenAI OpCo, LLC",
          "primaryGenre": "Productivity",
          "genreId": "6007",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/c7/eb/e6c7eb69-ade8-00b8-3454-d359249c6a0a/AppIcon-0-0-1x_U007epad-0-0-0-1-0-P3-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 2,
          "trackId": 835599320,
          "name": "TikTok - Videos, Shop & LIVE",
          "artistName": "TikTok Ltd.",
          "primaryGenre": "Entertainment",
          "genreId": "6016",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/c8/cf/06/c8cf0625-604f-e6c1-575f-e49014356b5b/TikTok_AppIcon26-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 3,
          "trackId": 544007664,
          "name": "YouTube",
          "artistName": "Google",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/20/ea/87/20ea8738-6fac-caea-ccc1-72d8375a2310/logo_youtube_2024_q4_color-0-0-1x_U007emarketing-0-0-0-7-0-0-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 4,
          "trackId": 431946152,
          "name": "로블록스(Roblox)",
          "artistName": "Roblox Corporation",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/ac/a5/f6/aca5f69c-4a2e-44ea-9db2-7d87acf84b9d/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 5,
          "trackId": 1094591345,
          "name": "Pokémon GO",
          "artistName": "Niantic, Inc.",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/b0/1d/a8/b01da803-6787-7011-bbb2-febab12f84de/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 6,
          "trackId": 6479970832,
          "name": "포켓몬 카드 게임 Pocket",
          "artistName": "The Pokemon Company",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/54/12/78/541278bd-ccac-156d-b027-a46e1cd536bb/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 7,
          "trackId": 553834731,
          "name": "캔디크러쉬사가",
          "artistName": "King",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/a1/c5/92/a1c59272-aace-ff82-0b16-ca93a87cb33c/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 8,
          "trackId": 529479190,
          "name": "클래시 오브 클랜",
          "artistName": "Supercell",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/ed/78/c5/ed78c5e2-9a0b-fd1f-58fa-a51a50a283ed/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 9,
          "trackId": 1053012308,
          "name": "클래시 로얄 (Clash Royale)",
          "artistName": "Supercell",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/37/80/1e/37801e4c-717a-6d48-5023-5770fdbb2e01/AppIcon-0-0-1x_U007emarketing-0-7-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 10,
          "trackId": 1482155847,
          "name": "로얄 매치 (Royal Match)",
          "artistName": "Dream Games",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/50/3d/ab/503dabf4-c381-e224-5630-5b031703c08d/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 11,
          "trackId": 1621328561,
          "name": "MONOPOLY GO! (모노폴리 GO!)",
          "artistName": "Scopely, Inc.",
          "primaryGenre": "Games",
          "genreId": "6014",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/35/63/c3/3563c36e-dc8f-45d4-1991-d9ab6db39557/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 12,
          "trackId": 324684580,
          "name": "Spotify (스포티파이) : 뮤직 & 팟캐스트 앱",
          "artistName": "Spotify",
          "primaryGenre": "Music",
          "genreId": "6011",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/d0/5c/0b/d05c0bcb-1d14-bf33-c74e-11518d8f245c/AppIcon-0-0-1x_U007epad-0-1-0-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 13,
          "trackId": 443904275,
          "name": "라인 LINE",
          "artistName": "LINE Corporation",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/03/ce/cb/03cecbf9-9517-859d-b6c3-59afc3be6fd5/basic_default-0-0-1x_U007epad-0-6-0-0-sRGB-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 14,
          "trackId": 1500855883,
          "name": "CapCut: 사진 및 동영상 에디터",
          "artistName": "Bytedance Pte. Ltd",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/bb/37/1f/bb371fbb-68b3-a368-186d-947bfad8e540/AppIcon-0-0-1x_U007emarketing-0-8-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 15,
          "trackId": 547702041,
          "name": "Tinder 틴더",
          "artistName": "Tinder LLC",
          "primaryGenre": "Lifestyle",
          "genreId": "6012",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/67/7b/27/677b27da-88b8-5b27-329a-eaedf9e07609/AppIcon-0-0-1x_U007emarketing-0-8-0-0-P3-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 16,
          "trackId": 985746746,
          "name": "Discord - 대화, 플레이, 어울리기",
          "artistName": "Discord Inc.",
          "primaryGenre": "Social Networking",
          "genreId": "6005",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/3c/fd/7d/3cfd7d5b-2976-2064-4023-c0bbfc4062ce/AppIcon-0-0-1x_U007epad-0-1-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 17,
          "trackId": 570060128,
          "name": "듀오링고(Duolingo): 언어 학습",
          "artistName": "Duolingo",
          "primaryGenre": "Education",
          "genreId": "6017",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/35/31/5e/35315e16-db2f-e88d-1821-6a1b8f67d936/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 18,
          "trackId": 897446215,
          "name": "Canva(캔바): 디자인, 사진편집, 동영상 편집",
          "artistName": "Canva",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/54/63/b5/5463b52f-ac99-4be1-6f74-fef35e4e3ce7/AppIcon-0-0-1x_U007epad-0-11-0-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 19,
          "trackId": 587366035,
          "name": "Picsart 픽스아트 AI 사진 & 동영상 편집",
          "artistName": "PicsArt, Inc.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/3f/78/a9/3f78a998-dbf1-a5d5-1bc7-6071a2183983/AppIcon-0-0-1x_U007emarketing-0-8-0-sRGB-85-220.png/100x100bb.jpg"
        },
        {
          "rank": 20,
          "trackId": 460177396,
          "name": "Twitch: Live Streaming",
          "artistName": "Twitch Interactive, Inc.",
          "primaryGenre": "Photo & Video",
          "genreId": "6008",
          "artworkUrl": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/e6/df/b3/e6dfb315-9c80-4c32-e688-9d38cfabd6d6/TwitchAppIcon-0-0-1x_U007epad-0-1-0-0-0-0-85-220.png/100x100bb.jpg"
        }
      ]
    }
  }
});

/**
 * Return a copy of the committed chart snapshot entries for one country/type.
 * Unknown countries or chart types return an empty array.
 *
 * @param {string|null|undefined} country
 * @param {string|null|undefined} type
 * @returns {import('../domain/chartRank.js').ChartBrowserEntry[]}
 */
export function getChartSnapshot(country, type) {
  const code = String(country ?? '').trim().toLowerCase();
  const chartType = String(type ?? '').trim();
  const entries = CHART_SNAPSHOT.countries?.[code]?.[chartType];
  if (!Array.isArray(entries)) return EMPTY_SNAPSHOT;
  return entries.map((entry) => ({ ...entry }));
}

/**
 * @returns {string[]} country codes covered by the committed snapshot.
 */
export function chartSnapshotCountries() {
  return Object.keys(CHART_SNAPSHOT.countries ?? {});
}
